/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class DataObjectsApi extends runtime.BaseAPI {
    /**
     * Delete a data blob.
     */
    async dataDataIdBlobsBlobIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdBlobsBlobIdDelete.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling dataDataIdBlobsBlobIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/blobs/{blobId}`
                .replace(`{${'dataId'}}`, String(requestParameters.dataId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a data blob.
     */
    async dataDataIdBlobsBlobIdDelete(requestParameters, initOverrides) {
        await this.dataDataIdBlobsBlobIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a data blob.
     */
    async dataDataIdBlobsBlobIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdBlobsBlobIdGet.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling dataDataIdBlobsBlobIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/blobs/{blobId}`
                .replace(`{${'dataId'}}`, String(requestParameters.dataId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a data blob.
     */
    async dataDataIdBlobsBlobIdGet(requestParameters, initOverrides) {
        const response = await this.dataDataIdBlobsBlobIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a data blob.
     */
    async dataDataIdBlobsBlobIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdBlobsBlobIdPatch.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling dataDataIdBlobsBlobIdPatch.');
        }
        if (requestParameters.dataBlobEdit === null ||
            requestParameters.dataBlobEdit === undefined) {
            throw new runtime.RequiredError('dataBlobEdit', 'Required parameter requestParameters.dataBlobEdit was null or undefined when calling dataDataIdBlobsBlobIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/blobs/{blobId}`
                .replace(`{${'dataId'}}`, String(requestParameters.dataId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.dataBlobEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a data blob.
     */
    async dataDataIdBlobsBlobIdPatch(requestParameters, initOverrides) {
        const response = await this.dataDataIdBlobsBlobIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of blobs of a data object.
     */
    async dataDataIdBlobsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdBlobsGet.');
        }
        const queryParameters = {};
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/blobs`.replace(`{${'dataId'}}`, String(requestParameters.dataId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of blobs of a data object.
     */
    async dataDataIdBlobsGet(requestParameters, initOverrides) {
        const response = await this.dataDataIdBlobsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new data blob.
     */
    async dataDataIdBlobsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdBlobsPost.');
        }
        if (requestParameters.dataBlobInsert === null ||
            requestParameters.dataBlobInsert === undefined) {
            throw new runtime.RequiredError('dataBlobInsert', 'Required parameter requestParameters.dataBlobInsert was null or undefined when calling dataDataIdBlobsPost.');
        }
        const queryParameters = {};
        if (requestParameters.customId !== undefined) {
            queryParameters['customId'] = requestParameters.customId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/blobs`.replace(`{${'dataId'}}`, String(requestParameters.dataId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.dataBlobInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new data blob.
     */
    async dataDataIdBlobsPost(requestParameters, initOverrides) {
        const response = await this.dataDataIdBlobsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a data object.
     */
    async dataDataIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}`.replace(`{${'dataId'}}`, String(requestParameters.dataId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a data object.
     */
    async dataDataIdDelete(requestParameters, initOverrides) {
        await this.dataDataIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get data object details.
     */
    async dataDataIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}`.replace(`{${'dataId'}}`, String(requestParameters.dataId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get data object details.
     */
    async dataDataIdGet(requestParameters, initOverrides) {
        const response = await this.dataDataIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit data object details.
     */
    async dataDataIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdPatch.');
        }
        if (requestParameters.dataObjectEdit === null ||
            requestParameters.dataObjectEdit === undefined) {
            throw new runtime.RequiredError('dataObjectEdit', 'Required parameter requestParameters.dataObjectEdit was null or undefined when calling dataDataIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}`.replace(`{${'dataId'}}`, String(requestParameters.dataId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.dataObjectEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit data object details.
     */
    async dataDataIdPatch(requestParameters, initOverrides) {
        const response = await this.dataDataIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of data uploads.
     */
    async dataDataIdUploadsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdUploadsGet.');
        }
        const queryParameters = {};
        if (requestParameters.blobId !== undefined) {
            queryParameters['blobId'] = requestParameters.blobId;
        }
        if (requestParameters.includeClosed !== undefined) {
            queryParameters['includeClosed'] = requestParameters.includeClosed;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/uploads`.replace(`{${'dataId'}}`, String(requestParameters.dataId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of data uploads.
     */
    async dataDataIdUploadsGet(requestParameters, initOverrides) {
        const response = await this.dataDataIdUploadsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new data upload.
     */
    async dataDataIdUploadsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdUploadsPost.');
        }
        if (requestParameters.dataUploadInsert === null ||
            requestParameters.dataUploadInsert === undefined) {
            throw new runtime.RequiredError('dataUploadInsert', 'Required parameter requestParameters.dataUploadInsert was null or undefined when calling dataDataIdUploadsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/uploads`.replace(`{${'dataId'}}`, String(requestParameters.dataId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.dataUploadInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new data upload.
     */
    async dataDataIdUploadsPost(requestParameters, initOverrides) {
        const response = await this.dataDataIdUploadsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a data upload.
     */
    async dataDataIdUploadsUploadIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdUploadsUploadIdDelete.');
        }
        if (requestParameters.uploadId === null ||
            requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId', 'Required parameter requestParameters.uploadId was null or undefined when calling dataDataIdUploadsUploadIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/uploads/{uploadId}`
                .replace(`{${'dataId'}}`, String(requestParameters.dataId))
                .replace(`{${'uploadId'}}`, String(requestParameters.uploadId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a data upload.
     */
    async dataDataIdUploadsUploadIdDelete(requestParameters, initOverrides) {
        await this.dataDataIdUploadsUploadIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a data upload.
     */
    async dataDataIdUploadsUploadIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.dataId === null ||
            requestParameters.dataId === undefined) {
            throw new runtime.RequiredError('dataId', 'Required parameter requestParameters.dataId was null or undefined when calling dataDataIdUploadsUploadIdGet.');
        }
        if (requestParameters.uploadId === null ||
            requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId', 'Required parameter requestParameters.uploadId was null or undefined when calling dataDataIdUploadsUploadIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data/{dataId}/uploads/{uploadId}`
                .replace(`{${'dataId'}}`, String(requestParameters.dataId))
                .replace(`{${'uploadId'}}`, String(requestParameters.uploadId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a data upload.
     */
    async dataDataIdUploadsUploadIdGet(requestParameters, initOverrides) {
        const response = await this.dataDataIdUploadsUploadIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of data object details. If objects belong to a stream they are not listed.
     */
    async dataGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.repositoryId !== undefined) {
            queryParameters['repositoryId'] = requestParameters.repositoryId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.timeRangeStart !== undefined) {
            queryParameters['timeRangeStart'] = requestParameters.timeRangeStart;
        }
        if (requestParameters.timeRangeEnd !== undefined) {
            queryParameters['timeRangeEnd'] = requestParameters.timeRangeEnd;
        }
        if (requestParameters.sortByTime !== undefined) {
            queryParameters['sortByTime'] = requestParameters.sortByTime;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        if (requestParameters.owner !== undefined) {
            queryParameters['owner'] = requestParameters.owner;
        }
        if (requestParameters.prefix !== undefined) {
            queryParameters['prefix'] = requestParameters.prefix;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of data object details. If objects belong to a stream they are not listed.
     */
    async dataGet(requestParameters = {}, initOverrides) {
        const response = await this.dataGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new data object.
     */
    async dataPostRaw(requestParameters, initOverrides) {
        if (requestParameters.dataObjectInsert === null ||
            requestParameters.dataObjectInsert === undefined) {
            throw new runtime.RequiredError('dataObjectInsert', 'Required parameter requestParameters.dataObjectInsert was null or undefined when calling dataPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.dataObjectInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new data object.
     */
    async dataPost(requestParameters, initOverrides) {
        const response = await this.dataPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const DataDataIdBlobsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const DataGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const DataGetSortByTimeEnum = {
    Desc: 'Desc',
    Asc: 'Asc',
};
//# sourceMappingURL=DataObjectsApi.js.map